import type { InputHTMLAttributes } from 'react';
import React from 'react';
import { Radio } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './RadioWithLabel.styles';

export interface RadioWithLabelProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
}

export const RadioWithLabel = ({ label, ...props }: RadioWithLabelProps) => (
  <label css={[styles.radioButtonWrapper, props.disabled && styles.radioButtonWrapperDisabled]}>
    <Radio {...props} aria-label={label} />
    <span css={styles.radioButtonLabelText}>{label}</span>
  </label>
);
